/* ======== Types ========= */
import type { Distribution } from "@memorang/types";
import { FlatList } from "react-native";
import type { FontSchemaType } from "../../font";
import type { QuickActionsChipType } from "../../types";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Container from "../Container";
import type { Stat } from "../RowStats";
/* ======== Components ========= */
import ContentHero from "./ContentHero";
import TagsSectionList, { type SectionTag } from "./TagsSectionList";

interface Props {
	distribution: Distribution;
	productTitle: string;
	productImage: string;
	stats?: Stat[];
	sectionTags: SectionTag[];
	handleNavigateToIAP: () => void;
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
	actionChips: QuickActionsChipType[];
	handleClickListItem: (selectedTagId: number, locked?: boolean) => void;
	appFont?: FontSchemaType;
}
const StudyPackView = ({
	distribution,
	productTitle,
	productImage,
	stats,
	sectionTags,
	handleNavigateToIAP,
	handleQuickActionPress,
	actionChips,
	handleClickListItem,
	appFont,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box flex={1}>
			<Container>
				<FlatList
					data={[]}
					keyExtractor={(item) => item}
					renderItem={() => <></>}
					ListHeaderComponent={
						isMobile ? (
							<ContentHero
								distribution={distribution}
								title={productTitle}
								stats={stats}
								image={productImage}
								handleQuickActionPress={handleQuickActionPress}
								actionChips={actionChips}
							/>
						) : null
					}
					ListFooterComponent={
						<TagsSectionList
							handleNavigateToIAP={handleNavigateToIAP}
							sectionTags={sectionTags}
							handleClickListItem={handleClickListItem}
							appFont={appFont}
						/>
					}
				/>
			</Container>
		</Box>
	);
};
export default StudyPackView;
